import { useCallback } from 'react';
import { useMappedState } from 'redux-react-hook';
import { getCurrency } from './selectors';

const useCurrency = () => {
  const mapState = useCallback((state) => ({ currency: getCurrency(state) }), [getCurrency]);
  return useMappedState(mapState);
};

export default useCurrency;
